// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"ImageSection_imageWrapper__4N5SX","hasContent":"ImageSection_hasContent__FPdWl","figure":"ImageSection_figure__3__OG","small":"ImageSection_small__uI9_b"};